import { render, staticRenderFns } from "./MortgageAddPopUp.vue?vue&type=template&id=622b79ec&scoped=true&"
import script from "./MortgageAddPopUp.vue?vue&type=script&lang=js&"
export * from "./MortgageAddPopUp.vue?vue&type=script&lang=js&"
import style0 from "./MortgageAddPopUp.vue?vue&type=style&index=0&id=622b79ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b79ec",
  null
  
)

export default component.exports